module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.label_info) ? _c('div', {
    attrs: {
      "id": "topic"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tag-info"
  }, [_c('div', {
    staticClass: "background",
    style: (("background-image:url(" + (_vm.label_info.label_cover) + ")"))
  }), _vm._v(" "), (_vm.label_info.brand && Object.keys(_vm.label_info.brand).length > 0) ? _c('div', {
    staticClass: "business-tag"
  }, [_c('div', {
    staticClass: "shop-info"
  }, [_c('img', {
    staticClass: "shop-logo",
    attrs: {
      "src": _vm.label_info.label_icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shop-name"
  }, [_vm._v(_vm._s(_vm.label_info.label_name))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-detail"
  }, [_vm._v("\n        " + _vm._s(_vm.label_info.brand.brand_desc) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "comments-count"
  }, [_vm._v("讨论 " + _vm._s(_vm.label_info.thread_count))])]) : _c('div', {
    staticClass: "normal-tag"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('span', {
    staticClass: "tag-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-name"
  }, [_vm._v(_vm._s(_vm.label_info.label_name))])]), _vm._v(" "), _c('div', {
    staticClass: "comments-count"
  }, [_vm._v("讨论 " + _vm._s(_vm.label_info.thread_count))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab_content",
    attrs: {
      "id": "tab_content"
    }
  }, [(_vm.label_info.location && Object.keys(_vm.label_info.location).length > 0) ? _c('div', {
    staticClass: "map-info",
    on: {
      "click": function($event) {
        return _vm.toMap(_vm.label_info.location.latitude, _vm.label_info.location.longitude)
      }
    }
  }, [_c('div', {
    staticClass: "address"
  }, [_c('span', [_vm._v("地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label_info.location.location_detail))])]), _vm._v(" "), _c('span', {
    staticClass: "map-icon"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");background-size: cover;background-position: center;background-repeat: no-repeat;height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");background-size: cover;background-position: center;background-repeat: no-repeat;height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])])])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "upload-tips",
    on: {
      "click": function($event) {
        return _vm.openApp(_vm.noMoreData)
      }
    }
  }, [_vm._v(_vm._s(!_vm.noMoreData ? (_vm.loading ? '正在加载中' : '上拉加载更多哦') : '啊哦加载完了，打开app查看更多有趣的话题吧') + "~")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c57b2bde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/tagList/tagList.vue
// module id = 125
// module chunks = 1